module.exports = __webpack_public_path__ + "fa-brands-400.c5ebe0b32dc1b5cc449a.ttf";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/src/assets/plugins/FontAweson/webfonts/fa-brands-400.ttf
// module id = ../../../../../src/assets/plugins/FontAweson/webfonts/fa-brands-400.ttf
// module chunks = styles